<div class="container-harbour-dues d-flex flex-column gap-5 my-5">
  <div class="card">
    <div class="card-body p-5">
      <div class="h5">History</div>
      <div class="row align-items-center mx-1 mb-2 py-2 bg-light">
        <div class="col-auto" style="width: 4rem"><span class="fa fa-2x" (click)="toggleOrder()"
                                                        [ngClass]="reverseOrder() ? 'fa-caret-up' : 'fa-caret-down'"></span>
        </div>
        <div class="col" style="max-width: 12rem">Timestamp</div>
        <div class="col">Action</div>
        <div class="col-auto" style="width: 20rem">User</div>
        <div class="col-auto" style="width: 20rem">Organisation</div>
      </div>

      @for (item of displayItems(); track item; let index = $index) {
        <ng-container [ngTemplateOutlet]="itemTemplate"
                      [ngTemplateOutletContext]="{ item : item, index: reverseOrder() ? items().length - index - 1 : index }"></ng-container>
      }
    </div>
  </div>
</div>

<ng-template #itemTemplate let-logItem="item" let-index="index">
  @let item = cast(logItem);
  @if (item) {
    <div class="text-dark always-enabled">
      <div class="row align-items-start item mx-1 my-2 py-2 border border-light">
        <div class="col-auto" style="width: 4rem">
          {{ index + 1 }}.
        </div>
        <div class="col" style="max-width: 12rem">
          <app-date-field [readonly]="true" [ngModel]="item.timestamp"></app-date-field>
        </div>
        <div class="col angular-with-newlines">{{ item.description }}</div>
        <div class="col-auto" style="width: 20rem">
          {{ item.user || '' }}
        </div>
        <div class="col-auto" style="width: 20rem">
          {{ item.fullName }}
        </div>
      </div>
    </div>
  }
</ng-template>
